

export const subItemOptions = [
  { value: 'fbxFormat', label: 'Binary FBX' },
  { value: 'dccObjectTypes', label: 'No unsupported objects' },
  { value: 'noNgons', label: 'No N-gons' },
  { value: 'facetedGeometry', label: 'No faceted geometry' },
  { value: 'nonManifoldVertices', label: 'Manifold geometry' },
  { value: 'missingRequiredTextures', label: 'PBR textures' },
  { value: 'embeddedTexturesFbx', label: 'No embed textures' },
  { value: 'textureAspectRatio', label: 'Square textures' },
  { value: 'textureResolutionNotPowerOf2', label: 'Power of 2 texture sizes' },
  { value: 'numberOfMaterialsPerObject', label: 'Assigned materials' },
  { value: 'overlappedUvPerUVIsland', label: 'No UV overlaps' },
  { value: 'numberOfUVs', label: 'UV unwrapped model' },
  { value: 'allowedCharacters', label: 'Allowed characters' },
]

export const cgtStandardOptions = [
  { value: 'fully_passed', label: 'Fully Passed' },
  {
    value: 'passed',
    label: 'Passed some checks',
    subitems: subItemOptions,
  },
  {
    value: 'failed',
    label: 'Failed some checks',
    subitems: subItemOptions,
  },
  { value: 'none', label: 'N/A' },
]
